import AzureRequest from "./request";

export default class DegreeLevel {

  constructor() {
    this.request = new AzureRequest('https://search-bot-orientation.search.windows.net/indexes/niveau-diplome/docs/search?api-version=2020-06-30-Preview');
  }

  getCourseLevel(course) {
    return this.request.post({
      search: course.Type_de_diplome
    }).then((response) => {
      let level = response.value[0] ? response.value[0].Niveau : false;
      return level;
    }).catch((error) => console.log(error));
  }

  getAll() {
    return this.request.post({
      search: '*'
    }).then((response) => {
      return response.value;
    }).catch((error) => console.log(error));
  }

  typesByLevel() {
    return this.getAll().then((degrees) => {
      return degrees.reduce((acc, degree) => {
        let degreeLevel = acc.find((item) => item.name === degree.Niveau)
        if (!degreeLevel) {
          acc.push({
            id: acc.length + 1,
            name: degree.Niveau,
            values: [degree.Diplome.toLowerCase()]
          })
        }
        else {
          degreeLevel.values.push(degree.Diplome.toLowerCase())
        }
        return acc;
      }, [])
    })
  }


}
